import { gql } from '@apollo/client';
import { MeetingPlacePageTenantListFragment } from '../fragments/meetingPlacePageTenantList';
import { MeetingPlacePageTenantShopListItemFragment } from '../fragments/meetingPlacePageTenantShopItem';
import { MeetingPlacePageTenantEntertainmentListItemFragment } from '../fragments/meetingPlacePageTenantEntertainmentItem';
import { MeetingPlacePageTenantFoodBevListItemFragment } from '../fragments/meetingPlacePageTenantFoodBevItem';
import { MeetingplacePageHomeMinifiedExtendedAttributeFiltersFragment } from '../fragments/meetingPlacePageHome-minified';

export const MEETING_PLACE_PAGE_TENANT_LIST_QUERY = gql`
  ${MeetingPlacePageTenantListFragment}
  ${MeetingPlacePageTenantShopListItemFragment}
  ${MeetingPlacePageTenantEntertainmentListItemFragment}
  ${MeetingPlacePageTenantFoodBevListItemFragment}
  query tenant_listing_query(
    $limit: Int!
    $skip: Int!
    $id: String!
    $locale: String!
  ) {
    meetingPlacePageTenantList(id: $id, locale: $locale) {
      ...MeetingPlacePageTenantList
      tenantsCollection(
        where: { sys: { publishedAt_exists: true } }
        limit: $limit
        skip: $skip
      ) {
        total
        items {
          ... on _Node {
            ... on MeetingPlacePageTenantShop {
              ...MeetingPlacePageTenantShopListItem
            }
            ... on MeetingPlacePageTenantFoodBeverage {
              ...MeetingPlacePageTenantFoodBevListItem
            }
            ... on MeetingPlacePageTenantEntertainment {
              ...MeetingPlacePageTenantEntertainmentListItem
            }
          }
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_TENANT_LIST_SEO_QUERY = gql`
  ${MeetingPlacePageTenantListFragment}
  query tenant_listing_seo_query(
    $id: String!
    $locale: String!
    $preview: Boolean
  ) {
    meetingPlacePageTenantList(id: $id, locale: $locale, preview: $preview) {
      ...MeetingPlacePageTenantList
    }
  }
`;

export const MEETING_PLACE_PAGE_TENANT_LIST_ID_QUERY = gql`
  query tenant_query($tagId: String!, $locale: String!) {
    meetingPlacePageTenantListCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
      locale: $locale
    ) {
      items {
        sys {
          id
        }
      }
    }
  }
`;

export const MEETING_PLACE_PAGE_HOME_MINIFIED_EXTENDED_ATTRIBUTE_FILTERS_QUERY = gql`
  ${MeetingplacePageHomeMinifiedExtendedAttributeFiltersFragment}
  query MeetingPlacePageHomeQuery(
    $tagId: String!
    $language: String!
    $preview: Boolean
  ) {
    meetingPlacePageHomeCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
      locale: $language
      preview: $preview
    ) {
      items {
        ...MeetingplacePageHomeMinifiedExtendedAttributeFilters
      }
    }
  }
`;

export async function getTenantListPageData(
  tenantListId: string,
  homePageContentfulId: string,
  node_locale: string,
  preview?: boolean,
) {
  const { getApolloClient } = await import('../apolloClient');
  const { fetchListingData } =
    await import('../../helpers/list-page/list-page-helpers');

  const client = getApolloClient(preview);

  const tenantRes = await fetchListingData(
    MEETING_PLACE_PAGE_TENANT_LIST_QUERY,
    'meetingPlacePageTenantList.tenantsCollection',
    tenantListId,
    node_locale,
    preview,
  );

  const homeRes = await client.query({
    query: MEETING_PLACE_PAGE_HOME_MINIFIED_EXTENDED_ATTRIBUTE_FILTERS_QUERY,
    variables: {
      language: node_locale,
      tagId: homePageContentfulId,
      preview: preview,
    },
    fetchPolicy: 'no-cache',
  });

  const homeData =
    (homeRes?.data as any)?.meetingPlacePageHomeCollection?.items[0] || null;

  return {
    meetingPlacePageTenantList: tenantRes,
    meetingPlacePageHomeCollection: homeData,
  };
}
